import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { Action } from '../../model/action';
import { EmitterService } from '../../service/EmitterService';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-date-time-range',
  templateUrl: './date-time-range.component.html',
  styleUrls: ['./date-time-range.component.css'],

})
export class DateTimeRangeComponent implements OnInit {
  setDateTimeDisplay = false;
  keyactive: string;
  tmpDate = {start: '', end: ''};
  selectedDate = {start: '', end: ''};
  changeDate: string;
  dateValide = true;
  _data: any;
  @Output() dateTimeRangeDisplayEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() idnexOfInco: EventEmitter<any> = new EventEmitter<any>();
  motifsOrigin: any = null;
  motifs = {
    'ABSENCE':  'Absence' ,
    'ARRIVEEANTICIPEE':  'Arrivée Anticipée' ,
    'DECHARGE':  'Décharge' ,
    'DEPASSEMENT':  'Dépassement' ,
    'DESTAFF':  'Destaff' ,
    'INCIDENTTECH':  'Incident technique' ,
    'OUBLIEDELOGUE':  'Oublie de délog' ,
    'PROBLEMEPOSITION':  'Problème position' ,
    'SEUILMOINS':  'Seuil -' ,
    'SEUILPLUS':  'Seuil +' ,
    'TRAVAILNONLOGUE':  'Travail non logué' ,
    'VISITEMED':  'Visite médicale'
  };
  constructor(private emit: EmitterService, public translateService: TranslateService) { }
  @Input('data')
  public set data(v: any) {
   this._data = v;
    if (this.motifsOrigin === null) {
      this.motifsOrigin = v.motif;
    }
  }
  @Input('start')
  public set start(v: any) {
    this.selectedDate.start = moment(v , 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    // moment(v, 'x').format('YYYY-MM-DD HH:mm:ss');
    this.tmpDate.start = moment(v , 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    // moment(v, 'x').format('YYYY-MM-DD HH:mm:ss');
  }
  @Input('index') index;
  @Input('end')
  public set end(v: string) {
    this.selectedDate.end = moment(v , 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    // moment(v, 'x').format('YYYY-MM-DD HH:mm:ss');
    this.tmpDate.end = moment(v , 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    // moment(v, 'x').format('YYYY-MM-DD HH:mm:ss');
  }
  ngOnInit() {
  }
  public formatBlock(r, w) {
    if(r.start != r.end && w.start != w.end) {
      if (r.start === w.start && r.end === w.end) { return [r]; }
      if (r.start === w.start && r.end !== w.end) { return [{start: r.start, end: w.end}, {start: w.end, end: r.end}]; }
      if (r.start !== w.start && r.end === w.end) { return [{start: r.start, end: w.start}, {start: w.start, end: r.end}]; }
      if (r.start !== w.start && r.end !== w.end) { return [{start: r.start, end: w.start}, {start: w.start, end: w.end},
        {start: w.end, end: r.end}];
      }
    }
  }
  public mapping(): any {
    let blocknew = [];
    if ( this.dateValide ) {
      blocknew = this.formatBlock(this.tmpDate, this.selectedDate);
      // console.log(blocknew);
      const user = JSON.parse(localStorage.getItem('INTELCIA_OAUTH_REMOTE_USER'));
      blocknew = blocknew.map((d, i) => {
        d['id']        = this._data.id;
        d['start'] = moment(d['start']).toDate();
        d['motif']     = this._data.motif && this._data.motif.code ? { code: this._data.motif.code, type: this._data.motif.type } : this._data.newMotif;
        d['newMotif']     = this._data.newMotif;
        d['type']     = this._data.type;
        d['source']     = this._data.source;
        d['updatedBy'] = (user !== null ? user.username : null);
        d['listMotifs'] = this._data.listMotifs;
        d['uid'] = new Date(d.start).getTime();
        if (d.start !== this.tmpDate.start || d.end !== this.tmpDate.end) {
          d['updated'] = true;
          d['tag'] = 'new';
        }
        return d;
      });
      }
      console.log('new mapping', blocknew)

      return blocknew;
  }
  public closePopset() {
    this.setDateTimeDisplay = false;
    this.selectedDate.start = this.tmpDate.start;
    this.selectedDate.end = this.tmpDate.end;
    this.dateTimeRangeDisplayEvent.emit(this.setDateTimeDisplay);
  }
  public valideDate() {
    let status = false;
    /*Original date*/
    const sd  = moment(this.tmpDate.start, 'YYYY-MM-DD HH:mm:ss');
    const ed  = moment(this.tmpDate.end, 'YYYY-MM-DD HH:mm:ss');
    /*Range date*/
    const ds  = moment(this.selectedDate.start, 'YYYY-MM-DD HH:mm:ss');
    const de  = moment(this.selectedDate.end, 'YYYY-MM-DD HH:mm:ss');

    if(moment(ds).format('YYYY-MM-DD HH:mm:ss') != moment(de).format('YYYY-MM-DD HH:mm:ss')) {
      status    = (ds.isSameOrAfter(sd)) && (ds.isSameOrBefore(ed))
        && (de.isSameOrAfter(sd)) && (de.isSameOrBefore(ed));
      this.dateValide = (status && (sd != ed));
      this.setDateTimeDisplay = !status;
      this.emit.PopupEvent.emit(this.mapping());
    } else {
      this.dateValide = false
    }
    this.dateTimeRangeDisplayEvent.emit(this.setDateTimeDisplay);
  }
  public openPicker(key: string) {
    this.idnexOfInco.emit({start: this.selectedDate.start, end: this.selectedDate.end});
    this.setDateTimeDisplay = true;
    this.keyactive = key;
    this.changeDate = this.selectedDate[key];
    return null;
  }
  public setDateTime(action: any, type: string) {
    let date;
  switch (type) {
      case 'add': date = moment(this.selectedDate[this.keyactive], 'YYYY-MM-DD HH:mm:ss')
        .add(1, action.toString()).format('YYYY-MM-DD HH:mm:ss');
        break;
      case 'rm': date = moment(this.selectedDate[this.keyactive], 'YYYY-MM-DD HH:mm:ss')
        .add(-1, action.toString()).format('YYYY-MM-DD HH:mm:ss');
        break;
    }

    this.selectedDate[this.keyactive] = date;
    this.changeDate = date;
  }
  public setTime(el: any, suffix: any) {
    let date;
    switch (suffix) {
      case 'HH': date = moment(this.selectedDate[this.keyactive], 'YYYY-MM-DD HH:mm:ss')
        .hours(el.value).format('YYYY-MM-DD HH:mm:ss'); break;
      case 'mm': date = moment(this.selectedDate[this.keyactive], 'YYYY-MM-DD HH:mm:ss')
        .minutes(el.value).format('YYYY-MM-DD HH:mm:ss'); break;
      case 'ss': date = moment(this.selectedDate[this.keyactive], 'YYYY-MM-DD HH:mm:ss')
        .seconds(el.value).format('YYYY-MM-DD HH:mm:ss'); break;
    }
    this.selectedDate[this.keyactive] = date;
    this.changeDate = date;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/date-time-range/date-time-range.component.ts